import Authorized from './Authorized';
import checkActionPermission from './CheckPermissions';
import renderAuthorize from './renderAuthorize';

Authorized.checkActionPermission = checkActionPermission;
const RenderAuthorize = renderAuthorize(Authorized);

export default RenderAuthorize;
